import { Calculation } from 'final-form-calculate'
import { emptyArray } from 'util/array'
import { metaPath } from 'util/metaPath'

import { HistoricoAtendimentoAdvancedFilterFormModel } from '../../model/model-historico'

const metaFiltroHistorico = metaPath<HistoricoAtendimentoAdvancedFilterFormModel>()

export function createFiltroHistoricoCalculation(): Calculation {
  return {
    field: [metaFiltroHistorico.exibirRegistrosInativos.absolutePath()],
    updates: {
      [metaFiltroHistorico.ciaps2.absolutePath()]: (
        exibirRegistrosInativos: boolean,
        allValues: HistoricoAtendimentoAdvancedFilterFormModel
      ) => {
        return exibirRegistrosInativos ? emptyArray : allValues.ciaps2
      },
      [metaFiltroHistorico.cids10.absolutePath()]: (
        exibirRegistrosInativos: boolean,
        allValues: HistoricoAtendimentoAdvancedFilterFormModel
      ) => {
        return exibirRegistrosInativos ? emptyArray : allValues.cids10
      },
    },
  }
}
